import React from 'react';
import { Box, Button, ListItemText, Menu, MenuItem, SxProps } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { QlfTopbarAction, colorPalette } from '@qualifio/ui-commons';
import { faArrowUpRightFromSquare } from '@fortawesome/pro-solid-svg-icons/faArrowUpRightFromSquare';
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons/faChevronDown';
import { faEye } from '@fortawesome/pro-solid-svg-icons/faEye';
import { faUser } from '@fortawesome/pro-solid-svg-icons/faUser';
import { faUserCrown } from '@fortawesome/pro-solid-svg-icons/faUserCrown';
import { makeStyles } from '@mui/styles';
import { useTranslation } from 'react-i18next';
import { usePortalUrl } from '../open-portal-with-internal-auth';

const useStyle = makeStyles(() => ({
  iconButton: {
    backgroundColor: colorPalette.yellow.main,
    color: 'white',
    padding: '0 !important',
    borderTopLeftRadius: '7px',
    borderBottomLeftRadius: '7px',
  },
  icon: {
    color: 'white',
  },
  optionsButton: {
    backgroundColor: colorPalette.yellow.dark,
    color: 'white',
    width: '20px',
    borderTopRightRadius: '7px',
    borderBottomRightRadius: '7px',
    marginRight: '10px',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    cursor: 'pointer',
  },
  optionsIcon: {
    width: '10px',
    margin: '2px',
  },
}));

export function GoToProgramButton({
  programId,
  profileId,
  variant = 'icon',
  sx,
}: {
  programId: string;
  profileId?: string;
  variant?: 'icon' | 'link';
  sx?: SxProps;
}) {
  const classes = useStyle();
  const { t } = useTranslation();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const { openPortal } = usePortalUrl(programId);

  const openOptions = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  return variant === 'icon' ? (
    <Box
      sx={{
        display: 'flex',
      }}
    >
      <div
        onClick={() => openPortal({ profileId, withInterAuth: true })}
        className={classes.iconButton}
      >
        <QlfTopbarAction
          aria-controls="settings-menu"
          aria-haspopup="true"
          icon={faEye}
          title={t('loyalty-topbar.actions.participant-frontend')}
          className={classes.icon}
        />
      </div>
      <div onClick={openOptions} className={classes.optionsButton}>
        <FontAwesomeIcon icon={faChevronDown} className={classes.optionsIcon} />
      </div>
      <Menu
        id="settings-menu"
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            openPortal({ profileId, withInterAuth: true });
          }}
        >
          <Box display="flex" alignItems="center">
            <FontAwesomeIcon icon={faUserCrown} />
            <ListItemText>{t('goToProgram.internal-auth')}</ListItemText>
          </Box>
        </MenuItem>
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            openPortal({ withInterAuth: false });
          }}
        >
          <Box display="flex" alignItems="center">
            <FontAwesomeIcon icon={faUser} />
            <ListItemText>{t('goToProgram.legacy-auth')}</ListItemText>
          </Box>
        </MenuItem>
      </Menu>
    </Box>
  ) : (
    <Button onClick={() => openPortal({ profileId, withInterAuth: true })} variant="text" sx={sx}>
      {t('loyalty-topbar.actions.participant-frontend')}
      <FontAwesomeIcon icon={faArrowUpRightFromSquare} style={{ marginLeft: 10 }} />
    </Button>
  );
}
